// import { createAsyncThunk } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../hooks/use-http";

const postVote = createAsyncThunk("vote/postVote", async ({ data }) => {
  const { request } = useHttp();
  return await request({
    url: "/about_us/vote/",
    method: "POST",
    data,
  });
});

const getVote = createAsyncThunk("vote/getVotes", async () => {
  const { request } = useHttp();
  return await request({
    url: "/about_us/vote/",
  });
});

export { postVote, getVote };
